import { FIFTEEN_MINUTES_IN_SECONDS } from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import {
    getS3SignedUrl as _getS3SignedUrl,
    uploadToS3 as _uploadToS3,
    extractS3KeyFromAWSUrl as _extractS3KeyFromAWSUrl,
    // @ts-ignore
} from "@my-scoot/exly-react-component-lib/build/cjs/features/Common/modules/S3/utils/S3.utils";

import {
    getS3SignedUrl as _getS3SignedUrlType,
    uploadToS3 as _uploadToS3Type,
    extractS3KeyFromAWSUrl as _extractS3KeyFromAWSUrlType,
} from "@my-scoot/exly-react-component-lib/build/types/features/Common/modules/S3/utils/S3.utils";

import { GenericAbortSignal, IUploadProgressCallback } from "./S3.interfaces";

/**
 * refer package function definition to understand the function
 *
 * Note: `isFilePublic` is deprecated
 */
export const uploadToS3 = ({
    file,
    bucket,
    key,
    abortSignal,
    onAbort,
    uploadProgressCallback,
    isFilePublic,
}: {
    file: File;
    bucket: string;
    key?: string;
    abortSignal?: GenericAbortSignal;
    onAbort?: () => void;
    uploadProgressCallback?: IUploadProgressCallback;
    isFilePublic?: boolean;
}) =>
    (_uploadToS3 as typeof _uploadToS3Type)({
        bucket,
        key: key ?? "",
        file,
        isFilePublic,
        lamdaBaseURL: process.env.NEXT_PUBLIC_AWS_LAMDA_BASE_URL || "",
        authorizationToken:
            process.env.NEXT_PUBLIC_AWS_AUTHORISATION_TOKEN || "",
        abortSignal,
        onProgress: uploadProgressCallback,
        onAbort,
    });

/**
 * refer package function definition to understand the function
 */
export const getS3SignedUrl = ({
    key,
    bucket,
    expires = FIFTEEN_MINUTES_IN_SECONDS,
}: {
    key: string;
    bucket: string;
    expires?: number;
}) =>
    (_getS3SignedUrl as typeof _getS3SignedUrlType)({
        bucket,
        key,
        expiresIn: expires,
        lamdaBaseURL: process.env.NEXT_PUBLIC_AWS_LAMDA_BASE_URL || "",
        authorizationToken:
            process.env.NEXT_PUBLIC_AWS_AUTHORISATION_TOKEN || "",
    });

export const getPublicFileS3Url = ({
    key,
    bucket,
    region = process.env.NEXT_PUBLIC_S3_REGION,
}: {
    key: string;
    bucket: string;
    region?: string;
}) => `https://${bucket}.s3.${region}.amazonaws.com/${key}`;

export const getPublicCdnUrl = ({
    key,
    bucket,
    region = process.env.NEXT_PUBLIC_S3_REGION,
}: {
    key: string;
    bucket: string;
    region?: string;
}) =>
    getPublicFileS3Url({ key, bucket, region }).replace(
        `https://${process.env.NEXT_PUBLIC_S3_CDN_BUCKET_EXLY_CONTENT}.s3.${region}.amazonaws.com`,
        process.env.NEXT_PUBLIC_S3_CDN_URL || ""
    );

export const extractS3KeyFromAWSUrl =
    _extractS3KeyFromAWSUrl as typeof _extractS3KeyFromAWSUrlType;
